export const countryCode = [
	{
		text: '中国大陆',
		code: '+86'
	},
	{
		text: '中国台湾地区',
		code: '+886'
	},
	{
		text: '中国香港',
		code: '+852'
	},
	{
		text: '中国澳门',
		code: '+853'
	},
	{
		text: '马来西亚',
		code: '+60'
	},
	{
		text: '新加坡',
		code: '+65'
	},
	{
		text: '日本',
		code: '+81'
	},
	{
		text: '韩国',
		code: '+82'
	},
	{
		text: '美国',
		code: '+1'
	},
	{
		text: '加拿大',
		code: '+1'
	},
	{
		text: '澳大利亚',
		code: '+61'
	},
	{
		text: '新西兰',
		code: '+64'
	},
	{
		text: '阿尔巴尼亚',
		code: '+355'
	},
	{
		text: '阿根廷',
		code: '+54'
	},
	{
		text: '阿联酋',
		code: '+971'
	},
	{
		text: '阿曼',
		code: '+968'
	},
	{
		text: '阿塞拜疆',
		code: '+994'
	},
	{
		text: '爱尔兰',
		code: '+353'
	},
	{
		text: '埃及',
		code: '+20'
	},
	{
		text: '爱沙尼亚',
		code: '+372'
	},
	{
		text: '安哥拉',
		code: '+244'
	},
	{
		text: '奥地利',
		code: '+43'
	},
	{
		text: '巴布亚新几内亚',
		code: '+675'
	},
	{
		text: '巴哈马',
		code: '+1242'
	},
	{
		text: '巴勒斯坦',
		code: '+970'
	},
	{
		text: '巴林',
		code: '+973'
	},
	{
		text: '巴拿马',
		code: '+507'
	},
	{
		text: '巴西',
		code: '+55'
	},
	{
		text: '白俄罗斯',
		code: '+375'
	},
	{
		text: '保加利亚',
		code: '+359'
	},
	{
		text: '贝宁',
		code: '+229'
	},
	{
		text: '比利时',
		code: '+32'
	},
	{
		text: '波兰',
		code: '+48'
	},
	{
		text: '玻利维亚',
		code: '+591'
	},
	{
		text: '伯利兹',
		code: '+501'
	},
	{
		text: '布基纳法索',
		code: '+226'
	},
	{
		text: '赤道几内亚',
		code: '+240'
	},
	{
		text: '丹麦',
		code: '+45'
	},
	{
		text: '德国',
		code: '+49'
	},
	{
		text: '多哥',
		code: '+228'
	},
	{
		text: '俄罗斯',
		code: '+7'
	},
	{
		text: '法国',
		code: '+33'
	},
	{
		text: '菲律宾',
		code: '+63'
	},
	{
		text: '芬兰',
		code: '+358'
	},
	{
		text: '佛得角',
		code: '+238'
	},
	{
		text: '冈比亚',
		code: '+220'
	},
	{
		text: '格林纳达',
		code: '+1473'
	},
	{
		text: '格鲁吉亚',
		code: '+995'
	},
	{
		text: '哥伦比亚',
		code: '+57'
	},
	{
		text: '哥斯达黎加',
		code: '+506'
	},
	{
		text: '圭亚那',
		code: '+592'
	},
	{
		text: '荷兰',
		code: '+31'
	},
	{
		text: '洪都拉斯',
		code: '+504'
	},
	{
		text: '吉布提',
		code: '+253'
	},
	{
		text: '吉尔吉斯斯坦',
		code: '+996'
	},
	{
		text: '几内亚',
		code: '+224'
	},
	{
		text: '几内亚比绍',
		code: '+245'
	},
	{
		text: '加蓬',
		code: '+241'
	},
	{
		text: '柬埔寨',
		code: '+855'
	},
	{
		text: '津巴布韦',
		code: '+263'
	},
	{
		text: '喀麦隆',
		code: '+237'
	},
	{
		text: '卡塔尔',
		code: '+974'
	},
	{
		text: '开曼群岛',
		code: '+1345'
	},
	{
		text: '克罗地亚',
		code: '+385'
	},
	{
		text: '科摩罗',
		code: '+269'
	},
	{
		text: '科威特',
		code: '+965'
	},
	{
		text: '肯尼亚',
		code: '+254'
	},
	{
		text: '拉脱维亚',
		code: '+371'
	},
	{
		text: '莱索托',
		code: '+266'
	},
	{
		text: '立陶宛',
		code: '+370'
	},
	{
		text: '卢森堡',
		code: '+352'
	},
	{
		text: '卢旺达',
		code: '+250'
	},
	{
		text: '罗马尼亚',
		code: '+40'
	},
	{
		text: '马达加斯加',
		code: '+261'
	},
	{
		text: '马尔代夫',
		code: '+960'
	},
	{
		text: '马拉维',
		code: '+265'
	},
	{
		text: '马里',
		code: '+223'
	},
	{
		text: '毛里求斯',
		code: '+230'
	},
	{
		text: '毛里塔尼亚',
		code: '+222'
	},
	{
		text: '蒙古',
		code: '+976'
	},
	{
		text: '秘鲁',
		code: '+51'
	},
	{
		text: '摩尔多瓦',
		code: '+373'
	},
	{
		text: '摩洛哥',
		code: '+212'
	},
	{
		text: '莫桑比克',
		code: '+258'
	},
	{
		text: '墨西哥',
		code: '+52'
	},
	{
		text: '纳米比亚',
		code: '+264'
	},
	{
		text: '南非',
		code: '+27'
	},
	{
		text: '尼加拉瓜',
		code: '+505'
	},
	{
		text: '尼日尔',
		code: '+227'
	},
	{
		text: '尼日利亚',
		code: '+234'
	},
	{
		text: '挪威',
		code: '+47'
	},
	{
		text: '葡萄牙',
		code: '+351'
	},
	{
		text: '瑞典',
		code: '+46'
	},
	{
		text: '瑞士',
		code: '+41'
	},
	{
		text: '萨尔瓦多',
		code: '+503'
	},
	{
		text: '塞尔维亚',
		code: '+381'
	},
	{
		text: '塞拉利昂',
		code: '+232'
	},
	{
		text: '塞内加尔',
		code: '+221'
	},
	{
		text: '塞浦路斯',
		code: '+357'
	},
	{
		text: '塞舌尔',
		code: '+248'
	},
	{
		text: '沙特阿拉伯',
		code: '+966'
	},
	{
		text: '斯里兰卡',
		code: '+94'
	},
	{
		text: '斯洛伐克',
		code: '+421'
	},
	{
		text: '斯洛文尼亚',
		code: '+386'
	},
	{
		text: '斯威士兰',
		code: '+268'
	},
	{
		text: '苏里南',
		code: '+597'
	},
	{
		text: '塔吉克斯坦',
		code: '+992'
	},
	{
		text: '泰国',
		code: '+66'
	},
	{
		text: '坦桑尼亚',
		code: '+255'
	},
	{
		text: '特立尼达和多巴哥',
		code: '+1868'
	},
	{
		text: '土耳其',
		code: '+90'
	},
	{
		text: '土库曼斯坦',
		code: '+993'
	},
	{
		text: '突尼斯',
		code: '+216'
	},
	{
		text: '危地马拉',
		code: '+502'
	},
	{
		text: '委内瑞拉',
		code: '+58'
	},
	{
		text: '文莱',
		code: '+673'
	},
	{
		text: '乌干达',
		code: '+256'
	},
	{
		text: '乌克兰',
		code: '+380'
	},
	{
		text: '乌拉圭',
		code: '+598'
	},
	{
		text: '乌兹别克斯坦',
		code: '+998'
	},
	{
		text: '西班牙',
		code: '+34'
	},
	{
		text: '希腊',
		code: '+30'
	},
	{
		text: '匈牙利',
		code: '+36'
	},
	{
		text: '牙买加',
		code: '+1876'
	},
	{
		text: '也门',
		code: '+967'
	},
	{
		text: '意大利',
		code: '+39'
	},
	{
		text: '以色列',
		code: '+972'
	},
	{
		text: '印度',
		code: '+91'
	},
	{
		text: '印度尼西亚',
		code: '+62'
	},
	{
		text: '英国',
		code: '+44'
	},
	{
		text: '英属维尔京群岛',
		code: '+1284'
	},
	{
		text: '约旦',
		code: '+962'
	},
	{
		text: '越南',
		code: '+84'
	},
	{
		text: '赞比亚',
		code: '+260'
	},
	{
		text: '乍得',
		code: '+235'
	},
	{
		text: '智利',
		code: '+56'
	}
];



// WEBPACK FOOTER //
// ./src/common/js/countryData.js